import moment from 'moment';

const isOlderThanYear = (date) => date && date.isValid() && date.isBefore(moment().subtract(1, 'year'));

const parsePassReset = (value) => {
  if (!value) {
    return null;
  }

  const date = moment(value, 'YYYY-MM-DD HH:mm:ss', true);

  return date.isValid() ? date : moment(value);
};

const parseRegDateTime = (regDate, regTime) => {
  if (!regDate) {
    return null;
  }

  const value = regTime ? `${regDate} ${regTime}` : regDate;
  const date = moment(value, ['DD.MM.YYYY HH:mm:ss', 'DD.MM.YYYY'], true);

  return date.isValid() ? date : null;
};

const isPasswordChangeRequired = (user) => {
  if (!user) {
    return false;
  }

  if (user.passReset) {
    return isOlderThanYear(parsePassReset(user.passReset));
  }

  return isOlderThanYear(parseRegDateTime(user.regDate, user.regTime));
};

export const isChangePasswordRoute = (pathname) => /\/change-password\/?$/.test(pathname);

export default isPasswordChangeRequired;
